import actionCreatorFactory from 'typescript-fsa';
import { Game } from '../types';
import { ApiError } from 'src/core/ApiStatus';

const factory = actionCreatorFactory('GAME');

export const allGamesActions = {
  get: factory.async<{}, Game[], ApiError>('GET_ALL'),
};
